import { Component, OnInit } from '@angular/core';

import { UserService } from '../../../../shared/services/user/user.service';
import { TranslatorService } from '../../../../shared/services/utils/translator.service';
import { DropdownBaseComponent } from '../dropdown-base.component';
import { DropDownService } from '../dropdown.service';

@Component({
  selector: 'ngx-timezone-type-dropdown',
  templateUrl: '../template-dropdown.html'
})
export class TimeZoneDropdownComponent extends DropdownBaseComponent implements OnInit {

  constructor(
    private readonly dropdownService: DropDownService,
    protected readonly translatorService: TranslatorService
  ) {
    super(translatorService);
  }

  ngOnInit(): void {
    super.ngOnInit();

    this.dropDownSettings = this.dropdownService.getConfiguration(this.singleSelection);
    this.itemsData = [
      { id: 'Europe/Madrid', name: this.translatorService.trans('timezone.Europe/Madrid') },
      { id: 'Atlantic/Canary', name: this.translatorService.trans('timezone.Atlantic/Canary') },
      { id: 'Europe/Lisbon', name: this.translatorService.trans('timezone.Europe/Lisbon') }
    ];
  }

}
